import { render, staticRenderFns } from "./sendAndApprove.vue?vue&type=template&id=68bb9492&scoped=true&"
import script from "./sendAndApprove.vue?vue&type=script&lang=js&"
export * from "./sendAndApprove.vue?vue&type=script&lang=js&"
import style0 from "./sendAndApprove.vue?vue&type=style&index=0&id=68bb9492&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bb9492",
  null
  
)

export default component.exports